import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import { BarragemData } from "../../context";
import { TableBarragem } from "../hbr_barragens";
import { CompanyData } from "../../pages";
import { Close } from "@mui/icons-material";

export interface SelectBarragemProps {
  removeButton?: boolean;
  initialBarragem?: BarragemData;
  companyFilter?: CompanyData;
  variant?: "text" | "contained" | "outlined";
  onSelect?: (barragem?: BarragemData) => void;
  children?: React.ReactNode;
}

export const SelectBarragem: React.FC<SelectBarragemProps> = ({ removeButton, initialBarragem, companyFilter, variant, onSelect, children }) => {
  const [open, setOpen] = useState(false);
  const [barragem, setBarragem] = useState<BarragemData | undefined>(initialBarragem);

  return <>
    <Button
      variant={variant}
      fullWidth
      onClick={() => setOpen(true)}
      endIcon={removeButton && barragem && <IconButton onClick={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        setOpen(false);
        setBarragem(undefined);
        onSelect?.(undefined);
      }}>
        <Close color="error" />
      </IconButton>}
    >
      {children ?? barragem?.nome ?? "Selecione uma Barragem"}
    </Button>

    <Dialog
      fullWidth
      open={open}
      maxWidth={"md"}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Box sx={{ height: "70vh" }}>
          <TableBarragem
            notEditable
            companyFilter={companyFilter}
            onSearch={(barragem) => {
              setOpen(false);
              setBarragem(barragem);
              onSelect?.(barragem);
            }}
          />
        </Box>
      </DialogContent>


      <DialogActions>
        <Button variant="contained" onClick={() => setOpen(false)}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog >
  </>;
};